import { render, staticRenderFns } from "./UnknownFileModal.vue?vue&type=template&id=7da8abb0&"
import script from "./UnknownFileModal.vue?vue&type=script&lang=js&"
export * from "./UnknownFileModal.vue?vue&type=script&lang=js&"
import style0 from "./UnknownFileModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports